import React from 'react'
import Helmet from 'react-helmet'
import { JsonLdProps } from './JsonLd.types'
import { getBody } from './JsonLd.utils'

const JsonLd = ({ type, object }: JsonLdProps) => {
  const body = getBody(type, object)
  return (
    <Helmet>
      <script type='application/ld+json'>
        {JSON.stringify({
          '@context': 'https://schema.org/',
          ...body
        })}
      </script>
    </Helmet>
  )
}

export default JsonLd
